import { render } from "./orderRequestForm.vue?vue&type=template&id=740c11e6&scoped=true"
import script from "./orderRequestForm.vue?vue&type=script&lang=js"
export * from "./orderRequestForm.vue?vue&type=script&lang=js"

import "./orderRequestForm.vue?vue&type=style&index=0&id=740c11e6&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-740c11e6"]])

export default __exports__